"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _MemberDayTablePane = _interopRequireDefault(require("./MemberDayTablePane.vue"));
var _MemberDayConfig = _interopRequireDefault(require("./MemberDayConfig.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MemberDay',
  components: {
    MemberDayTablePane: _MemberDayTablePane.default,
    MemberDayConfig: _MemberDayConfig.default
  },
  data: function data() {
    return {
      activeName: 'member_day_table',
      currentId: null,
      isEdit: false,
      showConfigTab: false,
      configKey: 0
    };
  },
  methods: {
    handleClick: function handleClick(tab) {
      this.activeName = tab.name;
    },
    handleTabRemove: function handleTabRemove(targetName) {
      if (targetName === 'member_day_config') {
        this.showConfigTab = false;
        this.currentId = null;
        this.isEdit = false;
        this.activeName = 'member_day_table';
      }
    },
    handleToConfig: function handleToConfig(id) {
      this.currentId = id || null;
      this.isEdit = !!id;
      this.showConfigTab = true;
      this.configKey++;
      this.activeName = 'member_day_config';
    },
    handleSuccess: function handleSuccess() {
      var _this = this;
      this.showConfigTab = false;
      this.currentId = null;
      this.isEdit = false;
      this.activeName = 'member_day_table';
      this.$nextTick(function () {
        if (_this.$refs.member_day_table) {
          _this.$refs.member_day_table.fetchData();
        }
      });
    },
    handleCancel: function handleCancel() {
      this.showConfigTab = false;
      this.currentId = null;
      this.isEdit = false;
      this.activeName = 'member_day_table';
    }
  }
};